import React, { useState, useEffect, useMemo, useRef } from "react";
import { Form, Button, Modal, notification, Input, Drawer, Tooltip, Tabs, Upload, Select, DatePicker, TimePicker } from "antd";
import { MdStickyNote2 } from "react-icons/md";
import { Breadcrumb } from "antd";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import { Link } from "react-router-dom";
import CommonTable from "./CommonTable";
import * as moment from "moment";
import { useNavigate, useParams } from "react-router-dom";
import { staffingUrl } from "../interceptor";
import { useMsal } from "@azure/msal-react";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import Chat from "../dashboard/components/Chat";
import Log from "../dashboard/components/Log";
import Scheduler from "../dashboard/components/Scheduler";
import { PiToolboxLight } from "react-icons/pi";
import { SlLocationPin } from "react-icons/sl";
import { FaPhoneAlt } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import { BsDownload } from "react-icons/bs";
import { FiEdit } from "react-icons/fi";
import ContentLoader from 'react-content-loader';
import axios from "axios";

dayjs.extend(utc);

export default function CandidateInfo() {

  const [api, contextHolder] = notification.useNotification();
  const { instance } = useMsal();
  const accDetails = instance.getActiveAccount();
  const userName = accDetails?.name;
  const Userid = accDetails["username"];

  const [InternalInterviewForm] = Form.useForm();
  const [candidateEditForm] = Form.useForm();
  const [interviewEditForm] = Form.useForm();

  const navigate = useNavigate();
  const { id } = useParams();
  const { TextArea } = Input;

  const [dataList, setDataList] = useState([]);
  const [globalDataList, setGlobalDataList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [candidate, setCandidate] = useState([]);
  const [count, setCount] = useState({
    submission_count: 0,
    interview_count: 0,
    selected_count: 0,
    onboard_count: 0,
    purchase_order_count: 0
  });
  const [candidateFilterValue, setCandidateFilterValue] = useState("Submitted");
  const [mentionedEmpId, setMentionedEmpId] = useState("");
  const [mentionedReqId, setMentionedReqId] = useState("");
  const [employeeLists, setEmployeeLists] = useState([]);
  const [reqLists, setReqLists] = useState([]);
  const [logData, setLogData] = useState([]);
  const [selectedCandidateDetails, setSelectedCandidateDetails] = useState({})
  const [showDetail, setShowDetail] = useState(false);
  const [backupLogData, setBackupLogData] = useState([]);
  const [filterValue, setFilterValue] = useState("All");
  const [billingIn, setBillingIn] = useState([]);
  const [interviewModalOpen, setInterviewModalOpen] = useState(false);
  const [showSchudeledHistory, setShowScheduledHistory] = useState(2);
  const [interviewStsOptions, setInterviewStsOptions] = useState([]);
  const [interviewData, setInterviewData] = useState([]);
  const [modalLoading, setModalLoading] = useState(false);
  const [interviewLevel, setInterviewLevel] = useState('');
  const [interviewDetails, setInterviewDetails] = useState([]);
  const [interviewFeedback, setInterviewFeedback] = useState(" ");
  const [interviewStatus, setInterviewStatus] = useState('Scheduled');
  const [location, setLocation] = useState(localStorage.getItem('current_location') || '')

  const size = "small";
  const columnVisibilityModel = {
    "s_no": false,
    "name": true,
    "skill": true,
    "experience": true,
    "status": true,
    "date": true,
  }

  const requirementTitle = () => {
    return (
      <>
        <div className="w-full">
          <Tabs
            type="card"
            size={size}
            // tabBarExtraContent={{
            //   right: <Scheduler id={id} />,
            // }}
            items={items}
          />
        </div>
      </>
    );
  };

  const openNotificationWithIcon = (req) => {
    api[req?.color]({
      message: req?.Title,
      description: req?.description,
      duration: req?.duration
    });
  };

  // const getDiscussion = async () => {
  //   try {
  //     const getCommentLog = await staffingUrl.get(`api/Log/getTalentEventLogs/0/${id}`);

  //     const commentData = getCommentLog.data.data.reverse();
  //     const alterCmtData = commentData.map(item => ({ ...item, createdDate: item.occuredAt.split('T')[0] }));

  //     const mergeData = [...alterCmtData];
  //     const alteredMergeData = Object.groupBy(mergeData, ({ createdDate }) => createdDate);

  //     const sortMergedData = Object.keys(alteredMergeData)
  //       .sort((a, b) => b.localeCompare(a))
  //       .reduce((acc, key) => {
  //         acc[key] = alteredMergeData[key];
  //         return acc;
  //       }, {});

  //     setLogData(sortMergedData);
  //     setBackupLogData(sortMergedData);
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  const getDiscussion = async () => {
    try {
      const getCommentLog = await staffingUrl.get(`api/Log/getTalentEventLogs/0/${id}`);
      const commentData = getCommentLog.data.data.reverse();
      const alterCmtData = commentData.map(item => ({ ...item, createdDate: item.occuredAt.split('T')[0] }));

      // NEW — fetch mail logs and normalize to same shape
      let mailLogData = [];
      try {
        const mailLogRes = await staffingUrl.get(`api/StaffMgnt/getCandidateMailLogs/${id}`);
        if (mailLogRes.data.status === 1) {
          mailLogData = mailLogRes.data.data.map(item => ({
            actionEvent: "Mail Sent",
            occuredAt: item.sent_date,
            createdDate: item.sent_date.split('T')[0],
            changedBy: Userid,
            username: userName || "System",
            changes: JSON.stringify([{
              content: `Automated: ${item.mail_type} mail was sent to ${item.email_id} at ${item.sent_date.replace('T', ' ').substring(0, 16)}`
            }])
          }));
        }
      } catch (err) {
        console.log(err);
      }

      const mergeData = [...alterCmtData, ...mailLogData];
      const alteredMergeData = Object.groupBy(mergeData, ({ createdDate }) => createdDate);

      const sortMergedData = Object.keys(alteredMergeData)
        .sort((a, b) => b.localeCompare(a))
        .reduce((acc, key) => {
          acc[key] = alteredMergeData[key];
          return acc;
        }, {});

      setLogData(sortMergedData);
      setBackupLogData(sortMergedData);
    } catch (error) {
      console.log(error);
    }
  };
  const handleCandidateFilter = (val) => {
    setCandidateFilterValue(val)
    if (val === "Submitted") {
      setDataList(globalDataList);
    } else {
      setDataList(globalDataList.filter(ls => ls.candidate_status === val));
    }
  };

  const formatDate = (createdDate) => {
    const now = new Date();
    const diffInSeconds = Math.floor((now - new Date(createdDate?.split("Z")[0])) / 1000);

    const seconds = diffInSeconds;
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);

    if (seconds < 60) {
      return "Just now";
    } else if (minutes < 60) {
      return minutes + " mins ago";
    } else if (hours < 24) {
      return hours + " hrs ago";
    } else {
      return `${createdDate.split('T')[0]} ${createdDate.split('T')[1].split(':')[0]}:${createdDate.split('T')[1].split(':')[1]}`
    }
  };

  const fetchReport = async () => {
    try {
      await staffingUrl.get(`api/StaffMgnt/getCandidatesList`).then(async (res) => {
        setCandidate(res.data);

        const getReqs = res.data?.map(item => {
          if (item.candidate_id === parseInt(id)) {
            return !!item.Associated_Requirements && item.Associated_Requirements.map(item2 => ({
              value: item2.req_title,
              label: item2.req_title,
              req_id: item2.req_id
            }))
          }
        }).filter(item => item).flat();

        const req_id = res?.data?.find((item) => item.candidate_id === parseInt(id));

        await staffingUrl
          .get(`api/StaffMgnt/getRequirementbyID?id=${req_id.billable_in_req || 0}`)
          .then((res) => {
            setBillingIn(res.data?.Requirement_title);
          });

        setReqLists(getReqs);
      }).catch((err) => { console.log(err); });

      await staffingUrl
        .get(`api/StaffMgnt/getEmployees/0`)
        .then((res) => {
          let empList = res?.data?.map((a) => ({
            value: a.username,
            label: a.username,
            emp_id: a.Emp_id,
            email: a.Email_id
          }));
          setEmployeeLists(empList);
        })
        .catch((err) => {
          console.log(err);
        });

      await getDiscussion();

      await staffingUrl
        .get(`api/StaffMgnt/listOfInterviewLevelStatus`)
        .then((res) => {
          const interview_sts_options = res.data?.data.map(item => ({
            label: item.level_name,
            value: `${item.level_name}_${item.level_id}`,
          }))
          setInterviewStsOptions(interview_sts_options);
        })
        .catch((err) => {
          console.log(err);
        });

      const fetchData = await staffingUrl.get(`api/StaffMgnt/Candidatereport`);

      const filteredCandidates = fetchData.data.list?.filter(item => item.candidate_id == parseInt(id));
      const statusValue = [];
      filteredCandidates?.forEach((item) => {
        if (item.candidate_status === 1) {
          statusValue.push({ ...item, candidate_status: "Submitted" })
        } else if (item.candidate_status === 2) {
          statusValue.push({ ...item, candidate_status: "Interview" })
        } else if (item.candidate_status === 3) {
          statusValue.push({ ...item, candidate_status: "Selected" })
        } else if (item.candidate_status === 4) {
          statusValue.push({ ...item, candidate_status: "Onboard" })
        } else if (item.candidate_status === 5) {
          statusValue.push({ ...item, candidate_status: "Purchase order" })
        } else if (item.candidate_status === 6) {
          statusValue.push({ ...item, candidate_status: "Onhold" })
        } else if (item.candidate_status === 7) {
          statusValue.push({ ...item, candidate_status: "Rejected" })
        } else if (item.candidate_status === 8) {
          statusValue.push({ ...item, candidate_status: "Screening Rejected" })
        } else if (item.candidate_status === 9) {
          statusValue.push({ ...item, candidate_status: "Internal Pre-Screening" })
        } else if (item.candidate_status === 10) {
          statusValue.push({ ...item, candidate_status: "Yet to Contact" })
        }
      });

      statusValue.map((item) => {
        if (item.req_status === 1) {
          item.req_status = "Ongoing"
        } else if (item.req_status === 2) {
          item.req_status = "Hold"
        } else if (item.req_status === 3) {
          item.req_status = "Closed"
        } else if (item.req_status === 4) {
          item.req_status = "Yet to Start"
        }
      });

      setCount({
        submission_count: statusValue?.length,
        interview_count: statusValue?.filter(item => item?.candidate_status === "Interview")?.length,
        selected_count: statusValue?.filter(item => item?.candidate_status === "Selected")?.length,
        onboard_count: statusValue?.filter(item => item?.candidate_status === "Onboard")?.length,
        purchase_order_count: statusValue?.filter(item => item?.candidate_status === "Purchase order")?.length
      });

      setGlobalDataList(statusValue)
      setDataList(statusValue);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.log(error);
    }
  };

  const fetchInterviewReport = async () => {

    const res = await staffingUrl.post(`/api/StaffMgnt/getInternalInterviewInfo/${id}`);
    const response = res.data;
    if (response.status == 1) {
      setInterviewData(response.data);
    }

  };

  const handlefilterLog = (id, name) => {
    if (id === 0 && name === "all") {
      setLogData(backupLogData);
    } else {
      let mergedData = {};
      Object.entries(backupLogData).forEach(([key, value]) => {
        let filteredItems = [];
        value?.forEach((item) => {
          if (item?.actionEvent === "Discussion Log") {
            JSON.parse(item.changes).forEach((candidate) => {
              if (candidate?.mentionedReq === name) {
                filteredItems.push(item);
              }
            });
          } else if (
            item?.actionEvent === "Candidate Mapping"
            || item?.actionEvent === "Candidate Removing"
            || item?.actionEvent === "Candidate Status Change"
            || item?.actionEvent === "Interview Scheduled"
            || item?.actionEvent === "Interview Status Change"
          ) {
            JSON.parse(item.changes).forEach((candidate) => {
              if (candidate?.req_id === id) {
                filteredItems.push(item);
              }
            })
          }
        });

        if (filteredItems.length > 0) {
          mergedData[key] = filteredItems;
        }
      });
      setLogData(mergedData)
    }
  };

  const sendFeedbackEmail = async (value) => {

    try {
      const res = await staffingUrl.post(`/api/StaffMgnt/sendFeedbackEmail`, value);
      const response = res.data;
      if (response.status == 1) {
        openNotificationWithIcon({
          color: 'success',
          Title: 'Success',
          description: "Feedback mail sent successfully",
          duration: 2
        });
      }
    }
    catch (error) {
      console.log(error);
    }
  };

  const logCandidateMail = async (payload) => {
    try {
      const response = await staffingUrl.post(`/api/StaffMgnt/logCandidateMail`, payload);
      console.log(response.data, 'logCandidateMail response');
    }
    catch (error) {
      console.log(error);
    }
  };

  const sendNotifyEmail = async (payload) => {
    try {

      const res = await staffingUrl.post(`/api/StaffMgnt/sendNotifyEmail`, payload);
      const response = res.data;
      if (response.status == 1) {
        openNotificationWithIcon({
          color: 'success',
          Title: 'Success',
          description: "Notification mail sent successfully",
          duration: 2
        });
      }
    }
    catch (error) {
      console.log(error);
    }
  };


  const sendInterviewerEmail = async (payload) => {
    try {
      const res = await staffingUrl.post(`/api/StaffMgnt/sendInterviewerNotifyEmail`, payload);
      if (res.data.status == 1) {
        openNotificationWithIcon({
          color: 'success',
          Title: 'Success',
          description: "Interviewer(s) notified successfully",
          duration: 2
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  // const SaveInterviewDetails = async (payload) => {
  //   try {

  //     const res = await staffingUrl.post(`/api/StaffMgnt/InternalInterviewDetails`, payload);
  //     if (res.data.status == 1) {
  //       // const EmailPayload = {
  //       //   toEmail: `${selectedCandidateDetails?.email_id}`,
  //       //   candidateName: `${selectedCandidateDetails?.firstname} ${selectedCandidateDetails?.lastname}`,
  //       //   interviewDate: payload.interview_date,
  //       //   interviewTime: payload.interview_time,
  //       //   interviewer: payload.interviewer,
  //       //   location: "TIDEL NEO LIMITED - No: 294/9, Kalanivasal village, Karaikudi Taluk, Sivagangai - 630002"
  //       // }

  //       const EmailPayload = {
  //         toEmail: `${selectedCandidateDetails?.email_id}`,
  //         candidateName: `${selectedCandidateDetails?.firstname} ${selectedCandidateDetails?.lastname}`,
  //         interviewDate: payload.interview_date,
  //         interviewTime: payload.interview_time,
  //         interviewer: payload.interviewer,
  //         interviewType: payload.interview_type,
  //         location: payload.interview_type === "Walk-in"
  //           ? "TIDEL NEO LIMITED - No: 294/9, Kalanivasal village, Karaikudi Taluk, Sivagangai - 630002"
  //           : "Virtual"
  //       }

  //       setInterviewModalOpen(false);
  //       sendNotifyEmail(EmailPayload);

  //       logCandidateMail({
  //         candidate_id: id,
  //         email_id: selectedCandidateDetails?.email_id,
  //         candidate_name: `${selectedCandidateDetails?.firstname} ${selectedCandidateDetails?.lastname}`,
  //         log_type: "Interview Scheduled"
  //       });
  //     }
  //   }
  //   catch (error) {
  //     console.log(error);
  //   }
  // };

  const SaveInterviewDetails = async (payload, interviewerList = []) => {
    try {
      const candidateName = `${selectedCandidateDetails?.firstname} ${selectedCandidateDetails?.lastname}`;
      let meetingLink = "";

      if (payload.interview_type === "Virtual") {
        const meetRes = await staffingUrl.post(`/api/StaffMgnt/createTeamsMeeting`, {
          organizerEmail: Userid,
          subject: `Interview - ${candidateName} (${payload.interview_level})`,
          interviewDate: payload.interview_date,
          interviewTime: payload.interview_time,
          durationMinutes: 60,
          attendees: [
            { name: candidateName, email: selectedCandidateDetails?.email_id },
            ...interviewerList
          ]
        });

        if (meetRes.data.status !== 1) {
          openNotificationWithIcon({
            color: 'error',
            Title: 'Teams meeting failed',
            description: meetRes.data.msg || "Could not create the Teams link",
            duration: 4
          });
          return;
        }
        meetingLink = meetRes.data.joinUrl;
      }

      const res = await staffingUrl.post(`/api/StaffMgnt/InternalInterviewDetails`, {
        ...payload,
        meeting_link: meetingLink
      });

      if (res.data.status == 1) {
        const location = payload.interview_type === "Walk-in"
          ? "TIDEL NEO LIMITED - No: 294/9, Kalanivasal village, Karaikudi Taluk, Sivagangai - 630002"
          : "Virtual (Microsoft Teams)";

        setInterviewModalOpen(false);

        sendNotifyEmail({
          toEmail: `${selectedCandidateDetails?.email_id}`,
          candidateName,
          interviewDate: payload.interview_date,
          interviewTime: payload.interview_time,
          interviewer: payload.interviewer,
          interviewType: payload.interview_type,
          location,
          meetingLink
        });

        if (interviewerList.length > 0) {
          sendInterviewerEmail({
            interviewers: interviewerList,
            candidateName,
            interviewDate: payload.interview_date,
            interviewTime: payload.interview_time,
            interviewLevel: payload.interview_level,
            interviewType: payload.interview_type,
            location,
            meetingLink
          });
        }

        logCandidateMail({
          candidate_id: id,
          email_id: selectedCandidateDetails?.email_id,
          candidate_name: candidateName,
          log_type: "Interview Scheduled"
        });
      }
    } catch (error) {
      console.log(error);
    }
  };


  const UpdateInterviewDetails = async (payload) => {
    try {
      const res = await staffingUrl.post(`/api/StaffMgnt/UpdateInterviewDetails`, payload);
      const response = res.data;
      if (response.status == 1) {
        const EmailPayload = {
          candidate_id: id,
          toEmail: `${selectedCandidateDetails?.email_id}`,
          candidateName: `${selectedCandidateDetails?.firstname} ${selectedCandidateDetails?.lastname}`,
          interviewFeedback: payload.interview_feedback,
          interviewer: interviewDetails.interviewer
        };

        setInterviewModalOpen(false);
        sendFeedbackEmail(EmailPayload);

        logCandidateMail({
          candidate_id: id,
          email_id: selectedCandidateDetails?.email_id,
          candidate_name: `${selectedCandidateDetails?.firstname} ${selectedCandidateDetails?.lastname}`,
          log_type: "Interview Feedback"
        });
      }
    }
    catch (error) {
      console.log(error);
    }
  };

  const handleChangeInterviewSts = (value, data, prevValue) => {

    const prevSts = interviewStsOptions?.find(item => item.label === prevValue)?.value;
    const status = interviewStsOptions?.find(item => item.value === value)?.label
    setInterviewStatus(prevValue);
    interviewEditForm.setFieldValue("interview_status", value);
    interviewEditForm.setFieldValue("id", data.id);
    interviewEditForm.setFieldValue("candidate_id", id);
    interviewEditForm.setFieldValue("interview_level", data.interview_level);
    interviewEditForm.setFieldValue("level_id", data.level_id);
    interviewEditForm.setFieldValue("old_status", prevSts);
    interviewEditForm.setFieldValue("interviewer", data.interviewer);
    interviewEditForm.setFieldValue("interview_status", status);
    setShowScheduledHistory(3);
  };

  const columns = useMemo(
    () => [
      {
        accessorKey: "s_no",
        header: "S.No",
        enableSorting: false,
        enableColumnFilter: false,
        size: 50,
        muiTableHeadCellProps: {
          align: "left",
        },
        muiTableBodyCellProps: {
          align: "center",
        },
      },
      {
        accessorKey: "req_title",
        header: "Requirement Title",
        size: 100,
        muiTableHeadCellProps: {
          align: "left",
        },
        muiTableBodyCellProps: {
          align: "left",
        },
        Cell: ({ row }) => {
          return (
            <>
              <div onClick={() => {
                navigate(`/requirement/info/${row.original.req_id}`);
              }} style={{
                color: "#6c5295",
                fontWeight: "500",
                display: 'flex',
                justifyContent: 'center'
              }}>
                {row.original.req_title || "-"}
              </div>
              {/* <div style={{ display: 'flex', justifyContent: 'center' }}>
            {row.original.req_title || "-"}
          </div> */}
            </>
          )
        }
      },
      {
        accessorKey: "customer",
        header: "Customer",
        size: 150,
        muiTableHeadCellProps: {
          align: "left",
        },
        muiTableBodyCellProps: {
          align: "left",
        },
        Cell: ({ row }) => {
          return <div style={{ display: 'flex', justifyContent: 'center' }}>
            {row.original.customer || "-"}
          </div>
        }
      },
      {
        accessorKey: "req_status",
        header: "Requirement Status",
        size: 80,
        muiTableHeadCellProps: {
          align: "left",
        },
        muiTableBodyCellProps: {
          align: "left",
        },
        Cell: ({ row }) => {
          return <div style={{ display: 'flex', justifyContent: 'center' }}>
            {row.original.req_status || "-"}
          </div>
        }
      },
      {
        accessorKey: "candidate_status",
        header: "Candidate Status",
        size: 100,
        muiTableHeadCellProps: {
          align: "left",
        },
        muiTableBodyCellProps: {
          align: "left",
        },
        Cell: ({ row }) => {
          let backgroundColor = '';
          let borderColor = '';
          let textColor = '#000';
          switch (row.original.candidate_status) {
            case 'Purchase order':
              backgroundColor = '#f17a2533';
              borderColor = '#f17a25';
              textColor = '#f17a25';
              break;
            case 'Onboard':
              backgroundColor = '#9b59b647';
              borderColor = '#9b59b6';
              textColor = '#9b59b6';
              break;
            case 'Interview':
              backgroundColor = '#3498db33';
              borderColor = '#3498db';
              textColor = '#3498db';
              break;
            case 'Selected':
              backgroundColor = '#82f28245';
              borderColor = '#0e890e';
              textColor = '#0e890e';
              break;
            case 'Rejected':
              backgroundColor = '#f64d4d4a';
              borderColor = '#e82929';
              textColor = '#e82929';
              break;
            case 'Onhold':
              backgroundColor = '#3366ff26';
              borderColor = '#3366ff';
              textColor = '#3366ff';
              break;
            default:
              backgroundColor = 'transparent';
              borderColor = 'gray';
          }
          return <div style={{
            backgroundColor,
            border: `1px solid ${borderColor}`,
            padding: '3px 5px 2px',
            color: textColor,
            textAlign: 'center',
            borderRadius: '5px'
          }}>
            {row.original.candidate_status}
          </div>
        }
      },
      {
        accessorKey: "created_date",
        header: "Mapped Date",
        size: 100,
        muiTableHeadCellProps: {
          align: "left",
        },
        muiTableBodyCellProps: {
          align: "left",
        },
        Cell: ({ row }) => {
          return <div style={{ display: 'flex', justifyContent: 'center' }}>
            {row.original.created_date.substring(0, 10)}
          </div>
        }
      },
    ],
    [dataList]
  );

  const items = [
    {
      key: "2",
      label: "Log Note",
      children: (
        <>
          <Chat
            employeeLists={employeeLists}
            reqLists={reqLists}
            mentionedEmpId={mentionedEmpId}
            mentionedReqId={mentionedReqId}
            setMentionedEmpId={setMentionedEmpId}
            setMentionedReqId={setMentionedReqId}
            getDiscussion={getDiscussion}
            id={id}
            openNotificationWithIcon={openNotificationWithIcon}
            from={"candidate"}
            setFilterValue={setFilterValue}
          />
          <Log
            logData={logData}
            from={"candidate"}
            dataList={dataList}
            handlefilterLog={handlefilterLog}
            filterValue={filterValue}
            setFilterValue={setFilterValue}
          />
        </>
      ),
    },
  ];

  const interviewColumns = useMemo(() => [
    {
      accessorKey: "interview_level",
      header: "Level",
      enableSorting: false,
      enableColumnFilter: false,
      size: 60,
      muiTableHeadCellProps: {
        align: "left",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
    },

    {
      accessorKey: "interview_type",
      header: "Interview Type",
      enableSorting: false,
      enableColumnFilter: false,
      size: 60,
      muiTableHeadCellProps: { align: "left" },
      muiTableBodyCellProps: { align: "center" },
      Cell: ({ row }) => <div>{row.original.interview_type || "-"}</div>
    },
    {
      accessorKey: "interview_date",
      header: "Date",
      enableSorting: false,
      enableColumnFilter: false,
      size: 100,
      muiTableHeadCellProps: {
        align: "left",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
      Cell: ({ row }) => (
        <div>{row.original.interview_date?.split("T")[0]}</div>
      )
    },
    {
      accessorKey: "interview_time",
      header: "Start Time",
      enableSorting: false,
      enableColumnFilter: false,
      size: 50,
      muiTableHeadCellProps: {
        align: "left",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
      Cell: ({ row }) => {
        const t = row.original.interview_time;
        return <div>{t ? (t.includes("T") ? t.split("T")[1] : t).substring(0, 5) : "-"}</div>;
      }
    },
    {
      accessorKey: "interviewer",
      header: "Interviewer",
      enableSorting: false,
      enableColumnFilter: false,
      size: 50,
      muiTableHeadCellProps: {
        align: "left",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
    },
    {
      accessorKey: "interview_status",
      header: "Status",
      enableSorting: false,
      enableColumnFilter: false,
      size: 80,
      muiTableHeadCellProps: {
        align: "left",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
      Cell: ({ row }) => (
        <Select
          className="w-full"
          size="small"
          placeholder="Select Status"
          value={row.original.interview_status}
          onChange={(value) => handleChangeInterviewSts(value, row.original, row.original.interview_status)}
        >
          {interviewStsOptions?.map((option) => (
            <Select.Option key={option.value} value={option.value}>
              {option.label}
            </Select.Option>
          ))}
        </Select>
      ),
    },
    {
      accessorKey: "feedback",
      header: "Feedback",
      enableSorting: false,
      enableColumnFilter: false,
      size: 100,
      muiTableHeadCellProps: {
        align: "left",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
      Cell: ({ row }) => (
        <div>
          {
            (!!row.original.feedback
              || row.original.feedback === ""
            )
              ? row.original.feedback
              : "-"
          }
        </div>
      )
    },
  ], [interviewData]);


  // const submitCandidateEditForm = () => {
  //   candidateEditForm.validateFields()
  //     .then(async (values) => {
  //       setInterviewDetails(values);
  //       const payload = {
  //         candidate_id: id,
  //         interview_date: dayjs(values.interview_date).format("YYYY-MM-DD"),
  //         interview_time: dayjs(values.interview_time).format("HH:mm"),
  //         interviewer: values.interviewer,
  //         interview_level: values.level,
  //         feedback: " ",
  //         interview_status: interviewStatus
  //       }
  //       SaveInterviewDetails(payload);
  //       candidateEditForm.resetFields();
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //       setModalLoading(false);
  //     })
  // };

  const submitCandidateEditForm = () => {
    candidateEditForm.validateFields()
      .then(async (values) => {
        const interviewerNames = (values.interviewer || []).join(", ");

        setInterviewDetails({ ...values, interviewer: interviewerNames });

        const payload = {
          candidate_id: id,
          interview_date: dayjs(values.interview_date).format("YYYY-MM-DD"),
          interview_time: dayjs(values.interview_time).format("HH:mm"),
          interviewer: interviewerNames,
          interview_type: values.interview_type,
          interview_level: values.level,
          feedback: " ",
          interview_status: interviewStatus
        };

        const interviewerList = (values.interviewer || [])
          .map((name) => {
            const emp = employeeLists.find((e) => e.value === name);
            return { name, email: emp?.email };
          })
          .filter((i) => i.email);

        SaveInterviewDetails(payload, interviewerList);
        candidateEditForm.resetFields();
      })
      .catch((err) => {
        console.log(err);
        setModalLoading(false);
      });
  };

  const submitInterviewForm = (values) => {
    setInterviewFeedback(values);
    const payload = {
      id: values.id,
      interview_feedback: values.interview_feedback || interviewFeedback,
      interview_status: values.interview_status
    }
    // SaveInterviewDetails(payload);
    UpdateInterviewDetails(payload);
  };

  const handleCandidateEdit = () => {
    navigate(`/candidatedashboard/${id}`);
  };

  const handleCandidateCancel = () => {
    setInterviewModalOpen(false);
    candidateEditForm.resetFields();
  };

  const openInterviewModal = () => {
    setInterviewModalOpen(true)
    setShowScheduledHistory(1)
    fetchInterviewReport();
  };

  useEffect(() => {
    fetchReport();
  }, []);

  useEffect(() => {
    if (!!candidate && id !== undefined) {
      const findCandidate = candidate?.find(item => item?.candidate_id === parseInt(id));
      setSelectedCandidateDetails(findCandidate);
    }
  }, [candidate, id]);

  return (
    <>
      <Modal
        className="candidate-modal"
        title="Schedule Internal Interview"
        visible={interviewModalOpen}
        onCancel={() => setInterviewModalOpen(false)}
        onOk={submitCandidateEditForm}
        maskClosable={false}
        footer={[
          <div className="flex justify-between">
            {showSchudeledHistory < 3 && (
              <div className="flex gap-2">
                <Button
                  className={showSchudeledHistory === 1 ? "save-btn" : ""}
                  onClick={() => setShowScheduledHistory(1)}
                >
                  Scheduled History
                </Button>
                <Button
                  className={showSchudeledHistory === 2 ? "save-btn" : ""}
                  onClick={() => setShowScheduledHistory(2)}
                  style={{ cursor: 'pointer' }}
                >
                  Schedule Interview
                </Button>
              </div>
            )}
            {showSchudeledHistory === 2 && (
              <div className="flex gap-2">
                <Button className="btn save-btn" onClick={handleCandidateCancel}>
                  Cancel
                </Button>
                <Button
                  className="btn save-btn"
                  onClick={submitCandidateEditForm}
                  loading={modalLoading}
                >
                  Save
                </Button>
              </div>
            )}
          </div>
        ]}
        width={1050}
      >
        <div className="flex items-center justify-between">
        </div>
        <div className="mt-3 flex items-center gap-2">
          <div style={{ fontSize: '14px', color: '#474d6a', fontWeight: '300' }}>|</div>
          <div className="flex items-center gap-2">
            <p style={{ fontSize: '15px', fontWeight: '500' }}>Candidate name :</p>
            <p style={{ fontSize: '15px', fontWeight: '500' }}> {selectedCandidateDetails?.firstname} {selectedCandidateDetails?.lastname}</p>
          </div>
        </div>
        {showSchudeledHistory === 1 && (
          <div className="requirment-table mt-3">
            <CommonTable
              data={interviewData}
              columns={interviewColumns}
              tableKey={"Interview_Info"}
              isLoading={isLoading}
              defaultColumn={{}}
              pinColumn={[]}
            />
          </div>
        )}
        {showSchudeledHistory === 2 && (
          <Form
            className="py-4 interview-form"
            form={candidateEditForm}
            onFinish={submitCandidateEditForm}
          >
            <div className="grid grid-cols-2 gap-x-5">
              <Form.Item
                name="level"
                className="custom-formItem"
                label="Interview Level"
                rules={[
                  {
                    required: true,
                    message: "Select the interview level",
                  },
                ]}
              >
                <Select
                  placeholder="Please select the level"
                  value={interviewLevel}
                  size="large"
                  options={[
                    {
                      key: 'Level 1',
                      value: "Level 1"
                    },
                    {
                      key: 'Level 2',
                      value: "Level 2"
                    },
                    {
                      key: 'Level 3',
                      value: "Level 3"
                    },
                    {
                      key: 'HR Interview',
                      value: "HR Interview"
                    }
                  ]}
                />
              </Form.Item>
              <Form.Item
                className="custom-formItem"
                name="interview_date"
                label="Interview Date"
                rules={[
                  {
                    required: true,
                    message: "Please select the date",
                  },
                ]}
              >
                <DatePicker
                  className="w-full"
                  size="large"
                  minDate={dayjs(new Date())}
                />
              </Form.Item>
            </div>





            <div className="grid grid-cols-2 gap-x-5">
              <Form.Item
                className="pt-2 custom-formItem"
                name="interview_time"
                label="Interview Time"
                rules={[{ required: true, message: "Select the time of interview" }]}
              >
                <TimePicker
                  format="HH:mm"
                  style={{ width: '100%' }}
                  size="large"
                  needConfirm={false}
                />
              </Form.Item>

              <Form.Item
                className="pt-2 custom-formItem"
                name="interview_type"
                label="Interview Type"
                rules={[{ required: true, message: "Select the interview type" }]}
              >
                <Select
                  size="large"
                  placeholder="Select interview type"
                  options={[
                    { label: "Virtual", value: "Virtual" },
                    { label: "Walk-in", value: "Walk-in" },
                  ]}
                />
              </Form.Item>
            </div>

            <div className="grid grid-cols-1 gap-x-5">
              <Form.Item
                className="pt-2 custom-formItem"
                name="interviewer"
                label="Interviewer"
                rules={[{ required: true, message: "Select at least one interviewer" }]}
              >
                <Select
                  mode="multiple"
                  showSearch
                  allowClear
                  size="large"
                  placeholder="Search and select interviewer(s)"
                  optionFilterProp="label"
                  maxTagCount="responsive"
                  options={employeeLists}
                />
              </Form.Item>
            </div>



          </Form>
        )}
        {showSchudeledHistory === 3 && (
          <Form
            className="pt-4 interview-form"
            form={interviewEditForm}
            onFinish={submitInterviewForm}
          >
            {/* <div>{`Interview ${interviewLevel} - ${interviewDetails.level}`}</div> */}
            <div className=" gap-x-5">
              <Form.Item
                className="custom-formItem"
                name="interview_feedback"
                label="Feedback"
              >
                <TextArea placeholder="Enter your feedback here" allowClear />
              </Form.Item>
              <Form.Item name="id" hidden>
                <Input />
              </Form.Item>
              <Form.Item name="candidate_id" hidden>
                <Input />
              </Form.Item>
              <Form.Item name="old_status" hidden>
                <Input />
              </Form.Item>
              <Form.Item name="interview_level" hidden>
                <Input />
              </Form.Item>
              <Form.Item name="level_id" hidden>
                <Input />
              </Form.Item>
              <Form.Item name="interviewer" hidden>
                <Input />
              </Form.Item>
              <Form.Item name="interview_status" hidden>
                <Input />
              </Form.Item>
            </div>
            <div className="mt-4 flex justify-end gap-2">
              <Button
                className="btn save-btn"
                htmlType="button"
                onClick={() => {
                  interviewEditForm.resetFields();
                  setShowScheduledHistory(1);
                }}
              >
                Cancel
              </Button>
              <Button
                htmlType="submit"
                className="btn save-btn"
              >
                Save
              </Button>
            </div>
          </Form>
        )}
      </Modal>
      <div style={{ display: "flex", gap: "1em" }}>
        <div className="w-[70%] border-r border-gray-300">
          {contextHolder}
          <Grid>
            <Breadcrumb
              items={[
                {
                  title: (
                    <span
                      className="cursor-pointer"
                      onClick={() => {
                        navigate("/candidatedashboard");
                      }}
                    >
                      Candidate Dashboard
                    </span>
                  ),
                },
                {
                  title: "Candidate Info",
                },
              ]}
            />
          </Grid>
          <Grid className="p-5 mt-3 mr-4" style={{ borderRadius: '5px', background: '#fff', border: '1px solid #dddddd99' }}>
            {isLoading
              ? (
                <div className="overflow-hidden">
                  <ContentLoader
                    speed={2}
                    width={900}
                    height={200}
                    viewBox="0 0 900 200"
                    backgroundColor="#f3f3f3"
                    foregroundColor="#ecebeb"
                  >
                    <rect x="0" y="0" rx="3" ry="3" width="100%" height="14" />
                    <rect x="0" y="20" rx="3" ry="3" width="90" height="10" />
                    <rect x="0" y="40" rx="3" ry="3" width="100%" height="8" />
                    <rect x="0" y="60" rx="3" ry="3" width="70" height="10" />
                    <rect x="0" y="80" rx="3" ry="3" width="100%" height="8" />
                    <rect x="0" y="100" rx="3" ry="3" width="90" height="10" />
                    <rect x="0" y="120" rx="3" ry="3" width="100%" height="10" />
                    <rect x="0" y="140" rx="3" ry="3" width="120" height="10" />
                    <rect x="0" y="160" rx="3" ry="3" width="150" height="12" />
                    <rect x="0" y="180" rx="3" ry="3" width="100%" height="14" />
                    <rect x="0" y="200" rx="3" ry="3" width="80" height="10" />
                    <rect x="0" y="220" rx="3" ry="3" width="100%" height="8" />
                    <rect x="0" y="240" rx="3" ry="3" width="80" height="10" />
                    <rect x="0" y="260" rx="3" ry="3" width="100%" height="8" />
                    <rect x="0" y="280" rx="3" ry="3" width="80" height="10" />
                  </ContentLoader>
                </div>
              )
              : (
                <>
                  <div className="flex items-center justify-between capitalize">
                    <div className="flex gap-4 items-center">
                      <p style={{ fontSize: '16px', fontWeight: '600' }}>
                        {selectedCandidateDetails?.firstname} {selectedCandidateDetails?.lastname}
                      </p>
                      <p
                        className="text-xs flex items-center gap-1"
                      >
                        <span className={`${selectedCandidateDetails?.is_enabled ? 'bg-green-600' : 'bg-red-600'} w-2.5 h-2.5 inline-block rounded-full`}></span>
                        {selectedCandidateDetails?.is_enabled ? 'Active' : 'In-active'}
                      </p>
                    </div>
                    <div className="flex items-center gap-2">
                      <div style={{ display: "flex", justifyContent: 'end', cursor: "pointer" }}>
                        <p
                          // style={{
                          //   fontSize: '12px',
                          //   border: "1px solid #479db5",
                          //   background: '#479db533',
                          //   color: '#000',
                          //   padding: '3px 10px',
                          //   borderRadius: '5px'
                          // }}
                          className="save-btn"
                          onClick={openInterviewModal}
                        // onClick={() => { setInterviewModalOpen(true), fetchInterviewReport() }}
                        >
                          Schedule Interview
                        </p>
                      </div>
                      <p
                        style={{
                          fontSize: '12px',
                          border: `
                    ${selectedCandidateDetails?.employee_status === "Non-Billable"
                              ? '1px solid #f64605'
                              : selectedCandidateDetails?.employee_status === "Fresher"
                                ? '1px solid #0e890e'
                                : selectedCandidateDetails?.employee_status === "Market"
                                  ? '1px solid #0e890e'
                                  : '1px solid #0e890e'
                            }`,
                          background: `
                    ${selectedCandidateDetails?.employee_status === "Non-Billable"
                              ? '#f646052e'
                              : selectedCandidateDetails?.employee_status === "Fresher"
                                ? '#82f28245'
                                : selectedCandidateDetails?.employee_status === "Market"
                                  ? '#82f28245'
                                  : '#82f28245'
                            }`,
                          color: `
                    ${selectedCandidateDetails?.employee_status === "Non-Billable"
                              ? '#f64605'
                              : selectedCandidateDetails?.employee_status === "Fresher"
                                ? '#0e890e'
                                : selectedCandidateDetails?.employee_status === "Market"
                                  ? '#0e890e'
                                  : '#0e890e'
                            }`,
                          padding: '3px 10px',
                          borderRadius: '5px'
                        }}
                      >
                        {
                          selectedCandidateDetails?.employee_status === "Non-Billable"
                            ? "Non Billing"
                            : selectedCandidateDetails?.employee_status === "Fresher"
                              ? "Fresher"
                              : selectedCandidateDetails?.employee_status === "Market"
                                ? "Market"
                                : !!billingIn && billingIn.length > 0
                                  ? `Billing in: ${billingIn}`
                                  : "Billable"
                        }
                      </p>
                      <p
                        style={{
                          fontSize: '12px',
                          border: `
                    ${selectedCandidateDetails?.employee_type === "Internal"
                              ? '1px solid #479db5'
                              : selectedCandidateDetails?.employee_type === "External"
                                ? '1px solid #f17a25'
                                : '1px solid #3366ff'
                            }`,
                          background: `
                    ${selectedCandidateDetails?.employee_type === "Internal"
                              ? '#479db533'
                              : selectedCandidateDetails?.employee_type === "External"
                                ? '#f17a2533'
                                : '#e1e8ff'
                            }`,
                          color: `
                    ${selectedCandidateDetails?.employee_type === "Internal"
                              ? '#479db5'
                              : selectedCandidateDetails?.employee_type === "External"
                                ? '#f17a25'
                                : '#3366ff'
                            }`,
                          padding: '3px 10px',
                          borderRadius: '5px'
                        }}
                      >
                        {selectedCandidateDetails?.employee_type || "-"}
                      </p>
                      <p className="cursor-pointer" onClick={handleCandidateEdit} style={{ fontSize: '16px', color: "#3366FF", border: '1px solid #3366FF', padding: '3px 10px', borderRadius: '5px' }}><FiEdit /></p>
                    </div>
                  </div>
                  <div className="mt-3 flex items-center gap-2">
                    <div className="flex items-center gap-2">
                      <PiToolboxLight style={{ color: '#717b9e', fontSize: '18px' }} />
                      <p style={{ fontSize: '12px', fontWeight: '500', color: '#474d6a' }}>{selectedCandidateDetails?.yoe?.substring(0, 2)} Yrs</p>
                    </div>
                    <div style={{ fontSize: '14px', color: '#e7e7f1', fontWeight: '300' }}>|</div>
                    <div className="flex items-center gap-2">
                      <SlLocationPin style={{ color: '#717b9e', fontSize: '16px' }} />
                      <p style={{ fontSize: '12px', fontWeight: '500', color: '#474d6a' }}>{selectedCandidateDetails?.city || "-"}</p>
                    </div>
                    <div
                      style={{
                        fontSize: "14px",
                        color: "#e7e7f1",
                        fontWeight: "300",
                      }}
                    >
                      |
                    </div>
                    <p style={{ fontSize: '13px', fontWeight: '500', color: '#474d6a' }}>ECTC :</p>
                    <p style={{ fontSize: '12px', fontWeight: '500', color: '#474d6a' }}>{selectedCandidateDetails?.expected_ctc || "-"}</p>
                    <div
                      style={{
                        fontSize: "14px",
                        color: "#e7e7f1",
                        fontWeight: "300",
                      }}
                    >
                      |
                    </div>
                    <p style={{ fontSize: '13px', fontWeight: '500', color: '#474d6a' }}>CCTC :</p>
                    <p style={{ fontSize: '12px', fontWeight: '500', color: '#474d6a' }}>{selectedCandidateDetails?.current_ctc || "-"}</p>
                    <div
                      style={{
                        fontSize: "14px",
                        color: "#e7e7f1",
                        fontWeight: "300",
                      }}
                    >
                      |
                    </div>
                    <p style={{ fontSize: '13px', fontWeight: '500', color: '#474d6a' }}>Work Mode :</p>
                    <p style={{ fontSize: '12px', fontWeight: '500', color: '#474d6a' }}>{selectedCandidateDetails?.work_mode || "-"}</p>
                  </div>
                  <div className="mt-3">
                    <div className="flex items-center gap-2">
                      <p style={{ fontSize: '13px', fontWeight: '500', color: '#474d6a', whiteSpace: 'nowrap' }}>Skill Set</p>
                      <div style={{ fontSize: '14px', color: '#e7e7f1', fontWeight: '300' }}>|</div>
                      <div className="flex flex-wrap flex-auto gap-2">
                        {selectedCandidateDetails?.skill_set
                          ?.split(",")
                          .filter((skill) => skill.trim() !== "").length > 0 ? (
                          selectedCandidateDetails.skill_set
                            .split(",")
                            .map((skill, index) => (
                              <p
                                key={index}
                                style={{
                                  fontSize: "12px",
                                  border: "1px solid #ddd",
                                  background: "#dddddd57",
                                  color: "#474d6a",
                                  padding: "3px 10px",
                                  borderRadius: "15px",
                                  fontWeight: "500",
                                  whiteSpace: "nowrap",
                                  display: "flex",
                                  justifyContent: "center",
                                }}
                              >
                                {skill.trim()}
                              </p>
                            ))
                        ) : (
                          <p
                            style={{
                              fontSize: "12px",
                              padding: "3px 10px",
                              fontWeight: "500",
                              display: "flex",
                              justifyContent: "center",
                            }}
                          >
                            -
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="mt-3">
                      <div className="flex items-center gap-2">
                        <p style={{ fontSize: '13px', fontWeight: '500', color: '#474d6a', whiteSpace: 'nowrap' }}>Prefered Locations</p>
                        <div
                          style={{
                            fontSize: "14px",
                            color: "#e7e7f1",
                            fontWeight: "300",
                            whiteSpace: 'nowrap'
                          }}
                        >
                          |
                        </div>
                        <div>
                          <p style={{ fontSize: '12px', fontWeight: '500', color: '#474d6a' }}>{selectedCandidateDetails?.preferred_state}</p>
                          <p style={{ fontSize: '12px', fontWeight: '500', color: '#474d6a' }}>{selectedCandidateDetails?.preferred_country}</p>
                          <p style={{ fontSize: '12px', fontWeight: '500', color: '#474d6a' }}>{selectedCandidateDetails?.preferred_city}</p>
                        </div>

                      </div>
                    </div>
                  </div>
                  <div className="flex items-center justify-between mt-2">
                    <div className="flex items-center gap-2">
                      <div className="flex items-center gap-2">
                        <FaPhoneAlt style={{ color: "#717b9e", fontSize: "12px" }} />
                        <p
                          style={{
                            fontSize: "13px",
                            fontWeight: "400",
                            color: "#474d6a",
                          }}
                        >
                          {selectedCandidateDetails?.contact_no || "-"}
                        </p>
                      </div>
                      <div
                        style={{
                          fontSize: "14px",
                          color: "#e7e7f1",
                          fontWeight: "300",
                        }}
                      >
                        |
                      </div>
                      <div className="flex items-center gap-2">
                        <MdEmail style={{ color: "#717b9e", fontSize: "16px" }} />
                        <p
                          style={{
                            fontSize: "13px",
                            fontWeight: "400",
                            color: "#474d6a",
                          }}
                        >
                          {selectedCandidateDetails?.email_id || "-"}
                        </p>
                      </div>
                      <div
                        style={{
                          fontSize: "14px",
                          color: "#e7e7f1",
                          fontWeight: "300",
                        }}
                      >
                        |
                      </div>
                      <div className="cursor-pointer flex flex-row"
                        onClick={() => window.open(selectedCandidateDetails?.resume)}
                      >
                        <BsDownload
                        />
                        <div className="mx-2.5">
                          <p className="capitalize" style={{ fontSize: '12px', fontWeight: '500', color: '#474d6a' }}>{selectedCandidateDetails?.resume?.split("/")?.pop()}</p>
                        </div>
                      </div>
                    </div>
                    <p
                      onClick={() => setShowDetail(!showDetail)}
                      style={{
                        fontSize: "12px",
                        fontWeight: "500",
                        color: "#6c5295",
                        cursor: "pointer",
                      }}
                    >
                      {showDetail ? (
                        <span className="close-detail">Close Experience</span>
                      ) : (
                        <span className="view-detail">View Experience</span>
                      )}
                    </p>
                  </div>
                  <div className="mt-3">
                    {showDetail && (
                      <div className="flex items-start gap-2">
                        {/* <LuClipboardList style={{ color: "#717b9e", fontSize: "22px" }} /> */}
                        {selectedCandidateDetails?.Previous_comp_details?.length > 0 ? (
                          <span style={{ fontSize: "13px", fontWeight: "400", color: "#474d6a" }}>
                            <div className="experience-table">
                              <table>
                                <thead>
                                  <tr>
                                    <th style={styles.header}>Company Name</th>
                                    <th style={styles.header}>Start Date</th>
                                    <th style={styles.header}>End Date</th>
                                    <th style={styles.header}>YOE</th>
                                    <th style={styles.header}>Role</th>
                                  </tr>
                                </thead>
                                <tbody>

                                  {selectedCandidateDetails?.Previous_comp_details?.map((item, index) => (
                                    <tr key={index}>
                                      <td style={styles.cell}>
                                        {item?.prev_comp_name || '-'}
                                      </td>
                                      <td style={styles.cell}>
                                        {dayjs(item?.prev_comp_startdate).format("YYYY-MM-DD") || '-'}
                                      </td>
                                      <td style={styles.cell}>
                                        {dayjs(item?.prev_comp_enddate).format("YYYY-MM-DD") || '-'}
                                      </td>
                                      <td style={styles.cell}>
                                        {item?.prev_yoe || '-'}
                                      </td>
                                      <td style={styles.cell}>
                                        {item?.prev_role || '-'}
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>

                          </span>
                        ) : (
                          <div className="label-text">No records to display</div>
                        )
                        }

                      </div>
                    )}
                  </div>
                </>
              )
            }
          </Grid>
          <Card sx={{ padding: "1em", paddingBottom: "2em", boxShadow: "none" }}>
            <Grid sx={{ background: "primary.main", marginTop: '0.2em' }} container spacing={2} style={{ paddingTop: '10px' }}>
              <Grid item xs={6} sx={{ display: "flex", flexDirection: "column", alignItems: "left", justifyContent: "left" }}>
                <Typography component="div" variant="h6" fontWeight={500} sx={{ fontSize: "18px", marginTop: "-18px", whiteSpace: 'nowrap', marginBottom: "10px" }}>
                  Candidate Information
                </Typography>
              </Grid>
            </Grid>
            <Grid sx={{ background: "primary.main" }} container spacing={2} justifyContent="center">
              <Grid item xs={12} md={12}>
                <Card sx={{ display: "flex", flexDirection: { xs: "column", md: "row" }, alignContent: "stretch", justifyContent: "space-between" }}>
                  <Link
                    onClick={() => { handleCandidateFilter("Submitted") }}
                    style={{
                      width: "100%",
                      textDecoration: "none",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center"
                    }}
                  >
                    <CardContent
                      sx={{
                        flex: "1 0 auto",
                        padding: "10px !important",
                        backgroundColor:
                          candidateFilterValue === "Submitted"
                            ? 'rgb(235 223 255)'
                            : '',
                        borderRadius:
                          candidateFilterValue === "Submitted"
                            ? '5px'
                            : ''
                      }}
                    >
                      <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                        <div>
                          <Typography
                            component="div"
                            sx={{ color: "#53596F", fontSize: "13px", fontWeight: "500", textAlign: 'center' }}
                          >
                            Mapping
                          </Typography>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'space-evenly', alignItems: 'center', width: '30%' }}>
                          {/* <FaPaperPlane style={{ fontSize: "18px", color: "#001F3F" }} /> */}
                          <div>
                            <Typography
                              variant="subtitle1"
                              color="text.primary"
                              sx={{
                                color: "#808080",
                                fontSize: "20px",
                                lineHeight: "25px",
                              }}
                              component="h6"
                              fontWeight={600}
                            >
                              {count?.submission_count}
                            </Typography>
                          </div>
                        </div>
                      </div>
                    </CardContent>
                  </Link>
                  <Link
                    onClick={() => { handleCandidateFilter("Interview") }}
                    style={{
                      width: "100%",
                      textDecoration: "none",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center"
                    }}
                  >
                    <CardContent
                      sx={{
                        flex: "1 0 auto",
                        padding: "10px !important",
                        backgroundColor:
                          candidateFilterValue === "Interview"
                            ? 'rgb(235 223 255)'
                            : '',
                        borderRadius:
                          candidateFilterValue === "Interview"
                            ? '5px'
                            : ''
                      }}
                    >
                      <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                        <div>
                          <Typography
                            component="div"
                            sx={{ color: "#53596F", fontSize: "13px", fontWeight: "500", textAlign: 'center' }}
                          >
                            Interview
                          </Typography>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'space-evenly', alignItems: 'center', width: '30%' }}>
                          {/* <GiDiscussion style={{ fontSize: "24px", color: "#3498db" }} /> */}
                          <div>
                            <Typography
                              variant="subtitle1"
                              color="text.primary"
                              sx={{
                                color: "#3498db",
                                fontSize: "20px",
                                lineHeight: "25px",
                              }}
                              component="h6"
                              fontWeight={600}
                            >
                              {count?.interview_count}
                            </Typography>
                          </div>
                        </div>
                      </div>
                    </CardContent>
                  </Link>
                  <Link
                    onClick={() => { handleCandidateFilter("Selected") }}
                    style={{
                      width: "100%",
                      textDecoration: "none",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center"
                    }}
                  >
                    <CardContent
                      sx={{
                        flex: "1 0 auto",
                        padding: "10px !important",
                        backgroundColor:
                          candidateFilterValue === "Selected"
                            ? 'rgb(235 223 255)'
                            : '',
                        borderRadius:
                          candidateFilterValue === "Selected"
                            ? '5px'
                            : ''
                      }}
                    >
                      <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                        <div>
                          <Typography
                            component="div"
                            sx={{ color: "#53596F", fontSize: "13px", fontWeight: "500", textAlign: 'center' }}
                          >
                            Selected
                          </Typography>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'space-evenly', alignItems: 'center', width: '30%' }}>
                          {/* <BsFillPersonCheckFill style={{ fontSize: "24px", color: "#27ae60" }} /> */}
                          <div>
                            <Typography
                              variant="subtitle1"
                              color="text.primary"
                              sx={{
                                color: "#27ae60",
                                fontSize: "20px",
                                lineHeight: "25px",
                              }}
                              component="h6"
                              fontWeight={600}
                            >
                              {count?.selected_count}
                            </Typography>
                          </div>
                        </div>
                      </div>
                    </CardContent>
                  </Link>
                  <Link
                    onClick={() => { handleCandidateFilter("Onboard") }}
                    style={{
                      width: "100%",
                      textDecoration: "none",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center"
                    }}
                  >
                    <CardContent
                      sx={{
                        flex: "1 0 auto",
                        padding: "10px !important",
                        backgroundColor:
                          candidateFilterValue === "Onboard"
                            ? 'rgb(235 223 255)'
                            : '',
                        borderRadius:
                          candidateFilterValue === "Onboard"
                            ? '5px'
                            : ''
                      }}
                    >
                      <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                        <div>
                          <Typography
                            component="div"
                            sx={{ color: "#53596F", fontSize: "13px", fontWeight: "500", textAlign: 'center' }}
                          >
                            Onboard
                          </Typography>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'space-evenly', alignItems: 'center', width: '30%' }}>
                          {/* <TbDiscountCheckFilled style={{ fontSize: "24px", color: "#9b59b6" }} /> */}
                          <div>
                            <Typography
                              variant="subtitle1"
                              color="text.primary"
                              sx={{
                                color: "#9b59b6",
                                fontSize: "20px",
                                lineHeight: "25px",
                              }}
                              component="h6"
                              fontWeight={600}
                            >
                              {count?.onboard_count}
                            </Typography>
                          </div>
                        </div>
                      </div>
                    </CardContent>
                  </Link>
                  <Link
                    onClick={() => { handleCandidateFilter("Purchase order") }}
                    style={{
                      width: "100%",
                      textDecoration: "none",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center"
                    }}
                  >
                    <CardContent
                      sx={{
                        flex: "1 0 auto",
                        padding: "10px !important",
                        backgroundColor:
                          candidateFilterValue === "Purchase order"
                            ? 'rgb(235 223 255)'
                            : '',
                        borderRadius:
                          candidateFilterValue === "Purchase order"
                            ? '5px'
                            : ''
                      }}
                    >
                      <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                        <div>
                          <Typography
                            component="div"
                            sx={{ color: "#53596F", fontSize: "13px", fontWeight: "500", textAlign: 'center', whiteSpace: 'nowrap' }}
                          >
                            Purchase Order
                          </Typography>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'space-evenly', alignItems: 'center', width: '30%' }}>
                          {/* <BsFillClipboard2DataFill style={{ fontSize: "24px", color: "#f39c12" }} /> */}
                          <div>
                            <Typography
                              variant="subtitle1"
                              color="text.primary"
                              sx={{
                                color: "#f39c12",
                                fontSize: "20px",
                                lineHeight: "25px",
                              }}
                              component="h6"
                              fontWeight={600}
                            >
                              {count?.purchase_order_count}
                            </Typography>
                          </div>
                        </div>
                      </div>
                    </CardContent>
                  </Link>
                </Card>
              </Grid>
            </Grid>
            <Grid sx={{ background: "primary.main", marginTop: '1em' }}>
              <Card sx={{ boxShadow: "none" }}>
                <Grid
                  sx={{
                    background: "primary.main",
                    marginTop: "1em",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <div className="requirment-table">
                    <CommonTable
                      data={dataList}
                      columns={columns}
                      tableKey={'Candidate_Info'}
                      isLoading={isLoading}
                      // customizeHeader={tableHead}
                      defaultColumn={columnVisibilityModel}
                      pinColumn={['candidate_id']}
                    />
                  </div>
                </Grid>
              </Card>
            </Grid>
          </Card>
        </div>
        <div className="chat-box flex-1 w-[29%] max-h-[calc(100vh-55px-1.5rem)]">
          {requirementTitle()}
        </div>
      </div>
    </>
  );
};

const styles = {
  header: {
    border: '1px solid #ddd',
    padding: '8px',
    textAlign: 'left',
    fontWeight: '500',
    color: '#403e6f'
  },
  cell: {
    border: '1px solid #ddd',
    padding: '8px',
    textAlign: 'left',
  },
  button: {
    padding: '6px 12px',
    backgroundColor: '#f44336',
    color: 'white',
    border: 'none',
    cursor: 'pointer',
  },
};
